
export default {
    set({commit}, response) {
      commit("setResponse", response);
    }
}